import { render } from "./ChangePlan.vue?vue&type=template&id=9d673726&scoped=true"
import script from "./ChangePlan.vue?vue&type=script&lang=js"
export * from "./ChangePlan.vue?vue&type=script&lang=js"

import "@/styles/pages/change-plan.scss?vue&type=style&index=0&id=9d673726&lang=scss&scoped=true&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d673726"]])

export default __exports__